export class ContractBlocks {
    constructor() {
        if ((window as any).isLoggedIn == true  && document.querySelector(".link-list-mem-only-js")) {
            let memOnlyContractIcons = document.querySelectorAll(".link-list-mem-only-js");
            let memOnlyArray = Array.prototype.slice.call(memOnlyContractIcons);
            memOnlyArray.forEach(function (icon) {
                icon.classList.add("visually-hidden");
            })
        }
        else if ((window as any).isLoggedIn == false && document.querySelector(".link-list-mem-logged-in-js")) {
            let memLoggedInContractIcons = document.querySelectorAll(".link-list-mem-logged-in-js");
            let memLoggedArray = Array.prototype.slice.call(memLoggedInContractIcons); 
            memLoggedArray.forEach(function (icon) {
                icon.classList.add("visually-hidden");
            })
        }
        else if ((window as any).isLoggedIn == true && document.querySelector(".link-list-mem-logged-in-js")) {
            let memLoggedInContractIcons = document.querySelectorAll(".link-list-mem-logged-in-js");
            let memLoggedArray = Array.prototype.slice.call(memLoggedInContractIcons);
            memLoggedArray.forEach(function (icon) {
                icon.classList.add("visually-hidden");
            })
        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/contract-blocks.ts